<ng-template [ngIf]="isSignup">
  <div id="agency-signup-home-button"
        class="customer-nav-button small-top-buffer"
        [class.active]="onAgencySignupHome"
        [routerLink]="['/account', 'signup']">
    <div class="title">{{isAgencySignup ? account?.accountName : customers[0]?.businessName}}</div>
    <div class="subtitle-body">{{canActivateAccount() ? "Ready to activate" : hasSetupAccountProfile ? "Add your clients" : "Set up your account"}}</div>
  </div>
  <div class="text-center small-top-buffer">
    <button *ngIf="canActivateAccount()" class="btn btn-block btn-secondary activate-button full-width" [routerLink]="['activation']" (click)="$event.stopPropagation()">Review & activate</button>
  </div>
  <hr class="small-top-buffer">
</ng-template>

<ng-template [ngIf]="!isSignup || hasSetupAccountProfile">
  <div id="customer-nav-header">
    <h4 *ngIf="!isWhiteLabel()" class="top-buffer subscription-list-lg">{{account?.agency ? 'My Clients' : 'My Subscriptions'}}</h4>

    <div *ngIf="!isSignup">
      <a *ngIf="overviewVisible" href="/customers" class="float-left">Overview</a>
      <a
        *ngIf="user?.canUpdateCustomer"
        [routerLink]="['/dashboard', 'customers', 'new']"
        [class.float-right]="customers.length > 1"
        id="new-customer-link">+ Add new {{account?.agency ? 'client' : 'subscription'}}</a>
    </div>
  </div>

  <!-- NON-MOBILE -->
  <div class="subscription-list-lg">
    <div class="mb-3">
      <search-bar placeholder="Filter" [(searchString)]="searchString" (valueChanged)="searchString = $event"></search-bar>
    </div>
    <div *ngIf="myCustomers | fuzzySearch:{
      searchString: searchString,
      keys: [this.searchCriteria],
      shouldSort: true
    }; let filteredMyCustomers">
      <div class="customer-nav-button"
        *ngFor="let customer of filteredMyCustomers; trackBy: trackById"
        [class.active]="isCustomerSelected(customer.id)"
        [routerLink]="computeRoute(customer)"
        [queryParams]="{page: null}"
        queryParamsHandling="merge"
        id="customer-nav-button-{{customer.id}}"
        (mouseover)="hover(customer?.id)"
        (mouseout)="hover(null)">
        <div
          class="float-right"
          [tooltip]="getAlertTooltipCopy(topAlert(customer, user))"
          [placement]="'top'"
          triggers="mouseenter:mouseleave"
          container="body"
          [ngClass]="topAlert(customer, user).class"
          [tooltip]="topAlert(customer, user).tooltip"
          *ngIf="!isAgencySignup && topAlert(customer, user)"
          [innerHTML]="topAlert(customer, user).render"></div>
        <div *ngIf="isAgencySignup" class="float-right fa" [class.fa-check]="showCheck(customer)" [class.text-green]="showCheck(customer) && !isCustomerSelected(customer.id)" [class.fa-times]="!showCheck(customer)" [class.text-danger]="!showCheck(customer) && !isCustomerSelected(customer?.id)" (mouseover)="hover(customer?.id)" (click)="removeCustomer(customer.id, $event)"></div>
        <div class="title">{{customerName(customer)}}
          <a *ngIf="isValetCustomer(customer) && !isEditspace"
            [tooltip]="customer | tooltipCopy"
            container="body"
            [placement]="'top'"
            triggers="mouseenter:mouseleave"
            class="link cursor-pointer">
            <i class="fas fa-bolt multipass"></i>
          </a>
        </div>
        <div class="subtitle-body">
          <span>{{subTitleSubscriptionTypeText(customer)}}</span>
          <span
            *ngIf="user?.canUpdateCustomer"
            [tooltip]="creditsTooltipCopy(customer)"
            container="body"
            [placement]="'top'"
            class="float-right chip">{{customer.multipass ? customer.balance : customer.postCreditsCount }}</span>
        </div>
        <client-setup-nav *ngIf="isAgencySignup && isCustomerSelected(customer.id)" [customer]="customer"></client-setup-nav>
      </div>
      <div *ngIf="searchString && filteredMyCustomers.length === 0"
        class="d-flex flex-row justify-content-between align-items-center">
        <div>No search results...</div>
        <button class="btn btn-outline-secondary btn-xs" (click)="searchString = ''">
          Clear filter
        </button>
      </div>
    </div>

    <!-- Agency Signup -->
    <div *ngIf="isAgencySignup"
      id="new-customer-button"
      class="customer-nav-button"
      [class.active]="addAnotherClientButtonSelected"
      [routerLink]="['clients', 'new']">
      <div class="title">
        <span style="vertical-align: middle;" class="fas fa-plus small-right-buffer"></span>
        <span class="text-center">
          {{customers.length > 0 ? "Add another client" : "Add your first client"}}
        </span>
      </div>
    </div>

    <div *ngIf="hiddenCustomers | fuzzySearch:{
      searchString: searchString,
      keys: ['displayName'],
      shouldSort: true
    }; let filteredHiddenCustomers">
      <div *ngIf="filteredHiddenCustomers.length > 0" class="option cursor-pointer" style="margin-top: 30px" (click)="onToggleHiddenExpanded()">
        {{hiddenExpanded ? 'Hide other' : 'Show other'}}
      </div>
      <div *ngIf="hiddenExpanded">
        <div
          id="customer-nav-button-{{customer.id}}"
          class="customer-nav-button"
          *ngFor="let customer of filteredHiddenCustomers"
          [class.active]="isCustomerSelected(customer.id)"
          [routerLink]="computeRoute(customer)"
          [queryParams]="{page: null}"
          queryParamsHandling="merge">
          <div class="float-right" [ngClass]="topAlert(customer, user).class" *ngIf="!isAgencySignup && topAlert(customer, user)" [innerHtml]="topAlert(customer, user).render"></div>
          <div class="title">{{customerName(customer)}}</div>
          <div class="subtitle-body">{{customerStateString(customer)}}</div>
        </div>
      </div>
    </div>

    <div *ngIf="expiredCustomers | fuzzySearch:{
      searchString: searchString,
      keys: ['displayName'],
      shouldSort: true
    }; let filteredExpiredCustomers">
      <div *ngIf="filteredExpiredCustomers.length > 0" class="option cursor-pointer" style="margin-top: 30px" (click)="onToggleExpiredExpanded()">
        {{expiredExpanded? 'Hide expired' : 'Show expired'}}
      </div>
      <div *ngIf="expiredExpanded">
        <div class="customer-nav-button"
              *ngFor="let customer of filteredExpiredCustomers"
              [class.active]="isCustomerSelected(customer?.id)"
              [routerLink]="computeRoute(customer)"
              [queryParams]="{page: null}"
              queryParamsHandling="merge"
              id="customer-nav-button-{{customer.id}}">
          <div
            *ngIf="!isAgencySignup && topAlert(customer, user)"
            [ngClass]="topAlert(customer, user).class"
            [innerHTML]="topAlert(customer, user).render"
            class="float-right"></div>
          <div class="title">{{customerName(customer)}}</div>
          <div *ngIf="user?.canUpdateCustomer" class="subtitle-body">
            {{customerStateString(customer)}}
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>